import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { categoriesAPI } from '../services/api';
import './Users.css';

const Categories = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    setLoading(true);
    try {
      const response = await categoriesAPI.getAll();
      const categoriesData = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      setCategories(categoriesData);
    } catch (error) {
      console.error('Error loading categories:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (category) => {
    const id = category.id || category.uuid;
    navigate(`/categories/${id}/edit`);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this category?')) return;
    try {
      await categoriesAPI.delete(id);
      loadCategories();
      toast.success('Category deleted!');
    } catch (error) {
      toast.error('Error deleting category: ' + (error.response?.data?.message || error.message));
    }
  };

  if (loading) {
    return <div className="loading">Loading categories...</div>;
  }

  return (
    <div className="users-container">
      <div style={{ marginBottom: '20px' }}>
        <Link to="/categories/new" className="btn btn-primary" style={{ display: 'inline-block' }}>
          + Add Category
        </Link>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Arabic Name</th>
              <th>Gender</th>
              <th>Icon</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {!loading && categories.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
                  No categories found
                </td>
              </tr>
            ) : (
              categories.map((category, idx) => (
                <tr key={category.id || category.uuid || `category-${idx}`}>
                  <td>{category.name || 'N/A'}</td>
                  <td>{category.name_ar || 'N/A'}</td>
                  <td>{category.gender || 'both'}</td>
                  <td>
                    {category.icon_url ? (
                      <img
                        src={category.icon_url}
                        alt={category.name || 'Category'}
                        style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '4px' }}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.parentElement.textContent = 'N/A';
                        }}
                      />
                    ) : (
                      'N/A'
                    )}
                  </td>
                  <td className="actions">
                    <button type="button" className="btn btn-primary" onClick={() => handleEdit(category)}>
                      Edit
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => handleDelete(category.id || category.uuid)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Categories;
